import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'awId',
})
export class IdPipe implements PipeTransform {
  private readonly joinChar = '-';

  transform(baseId: string, ...parts: Array<string>): string {
    return [baseId, ...parts].join(this.joinChar);
  }
}
